// src/data/commandsNav.js
import commandList from './commands';

const grouped = commandList.reduce((acc, cmd) => {
  if (!acc[cmd.category]) acc[cmd.category] = [];
  acc[cmd.category].push({ label: cmd.name, path: cmd.path });
  return acc;
}, {});

const commandsNav = Object.entries(grouped).map(([category, children]) => ({
  label: category,
  children,
}));

export default commandsNav;